import type { FaireProductEntity } from "../../entity_types/product";

export const p_5ap9u557w6: FaireProductEntity = {
  token: "p_5ap9u557w6",
  type: "product",
  name: "Bedford Organic - 12oz - Whole Bean Coffee",
  brandToken: "b_4db0zb0iws",
  brandName: "Partners Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/c4368cf0a5380b11ce6187f42ce51bb9b5fb5df4e390516fe1e9011ebe04394e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/707a75d1a33364fda15c43f2ece9dfccfdd08d8e8a9c9b2bb23441f56e0e278c.png",
    "https://cdn.faire.com/fastly/741f0bbb0ebcfc83b9c1c3aa8e11d7f214b20cecb2c7f7d1c470caeec275cbc8.png",
    "https://cdn.faire.com/fastly/929d560c58cfdcf4d10c466e8fa279fd7534c76544545989ef852a3a1658ab00.png",
    "https://cdn.faire.com/fastly/dfa5461672ef6250a18dd08e1daf8146e0215bfbff679a3e8b377d628a76fe2b.png"
  ],
  priceDollars: 12.44,
  description: "Named for our original cafe and roastery, Bedford was conceived as a modern espresso offering: a well-developed medium roast with prominent yet versatile fruit notes. Citrus and stone fruit shine in an espresso shot or Americano, while sweet, brown sugary notes prevail in milk drinks.   \n\nBedford consists of coffees from some of our longest-running farm relationships: Suke Quto in Guji, Ethiopia, and the extended Pillimué Family of Cauca, Colombia, each showing an incredible commitment to responsible farming practices. \n\n\nA perfect fall favorite!",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:36.256Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
